import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import DocumentTemplates from './document_templates';
import FileDropzone from './file_dropzone';
import FileTypeRadio from './file_type_radio';
import Chip from '@material-ui/core/Chip';
import { configStatusesTranslateMap } from '../../../config/statuses';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField/TextField';
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
    orderInformationBlock: {
        borderWidth: '1px',
        borderColor: '#c0c0c0',
        borderStyle: 'solid',
        borderRadius: '4px',
        padding: '15px',
    },
    alignRight: {
        textAlign: 'right',
    },
}));

const SendStatusForm = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const {
        zajavl,
        handleChangeComment,
        comment,
        templates,
        loadedFiles,
        handleOnDropFile,
        handleRemoveFile,
        handleDownloadFile,
        handleChangeFileType,
        selectedFileType,
        handleSendStatus,
        sendStatusDisabled,
    } = props;
    return (
        <div className={classes.orderInformationBlock}>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12}>
                    <Chip
                        size="small"
                        color="primary"
                        label={configStatusesTranslateMap[zajavl.status]
                            ? t(configStatusesTranslateMap[zajavl.status])
                            : t('unknown_status')}
                    />
                </Grid>
                <Grid item md={12} xs={12}>
                    <DocumentTemplates templates={templates}/>
                </Grid>
                <Grid item md={4} xs={12}>
                    <FileTypeRadio handleChange={handleChangeFileType} value={selectedFileType}/>
                </Grid>
                <Grid item md={8} xs={12}>
                    <FileDropzone
                        onDrop={handleOnDropFile}
                        handleRemoveFile={handleRemoveFile}
                        handleDownloadFile={handleDownloadFile}
                        files={loadedFiles} />
                </Grid>
                <TextField
                    fullWidth
                    label={t('comment')}
                    value={comment ? comment: ''}
                    onChange={handleChangeComment}
                    variant="outlined"
                    multiline={true}
                    rows={2}
                />
                <Grid item md={12} xs={12} className={classes.alignRight}>
                    <Button
                        className={classes.button}
                        variant="contained"
                        color="primary"
                        size="small"
                        disabled={sendStatusDisabled}
                        onClick={() => {
                            handleSendStatus(zajavl.id);
                        }}>
                        {t('submit')}
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
};
export default SendStatusForm;
